import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import { mergeRefs } from '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import Box from '../../Box/index.esm.js';
import Card from '../../Card/index.esm.js';
import Transition from '../../Transition/index.esm.js';
import { useMenuList } from '../use-menu.esm.js';

var MenuList = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var children = props.children,
      _props$width = props.width,
      width = _props$width === void 0 ? 'w-60' : _props$width,
      rest = _objectWithoutPropertiesLoose(props, ["children", "width"]);

  var _useMenuList = useMenuList(rest),
      open = _useMenuList.open,
      placement = _useMenuList.placement,
      ownProps = _objectWithoutPropertiesLoose(_useMenuList, ["open", "placement"]);

  var ownRef = mergeRefs(ownProps.ref, ref);
  var transform = {};

  var _placement$split = placement.split('-'),
      position = _placement$split[0]; // TODO: Move this stuff to a helper?


  switch (position) {
    case 'bottom':
      transform.from = '-translate-y-4';
      transform.to = 'translate-y-0';
      break;

    case 'right':
      transform.from = '-translate-x-4';
      transform.to = 'translate-x-0';
      break;

    case 'left':
      transform.from = 'translate-x-4';
      transform.to = 'translate-x-0';
      break;

    default:
    case 'top':
      transform.from = 'translate-y-4';
      transform.to = 'translate-y-0';
      break;
  }

  switch (placement) {
    case 'bottom':
      transform.origin = 'origin-top';
      break;

    case 'bottom-start':
      transform.origin = 'origin-top-left';
      break;

    case 'bottom-end':
      transform.origin = 'origin-top-right';
      break;

    case 'top':
      transform.origin = 'origin-bottom';
      break;

    case 'top-start':
      transform.origin = 'origin-bottom-left';
      break;

    case 'top-end':
      transform.origin = 'origin-bottom-right';
      break;

    case 'left':
      transform.origin = 'origin-right';
      break;

    case 'left-start':
      transform.origin = 'origin-top-right';
      break;

    case 'left-end':
      transform.origin = 'origin-bottom-right';
      break;

    case 'right':
      transform.origin = 'origin-left';
      break;

    case 'right-start':
      transform.origin = 'origin-top-left';
      break;

    case 'right-end':
      transform.origin = 'origin-bottom-left';
      break;

    default:
      transform.origin = 'origin-center';
      break;
  }

  return React__default.createElement(Box, _extends({
    zIndex: "z-20",
    outline: "outline-none"
  }, ownProps, {
    ref: ownRef
  }), React__default.createElement(Transition, {
    show: open,
    enter: ['ease-out', 'duration-75'],
    enterFrom: ['opacity-0', transform.from, 'scale-75'],
    enterTo: ['opacity-100', transform.to, 'scale-100'],
    leave: ['ease-in', 'duration-100'],
    leaveFrom: ['opacity-100', transform.to, 'scale-100'],
    leaveTo: ['opacity-0', transform.from, 'scale-75']
  }, React__default.createElement(Card, {
    transform: "transform",
    transformOrigin: transform.origin,
    borderRadius: "rounded-lg",
    borderWidth: "border-0",
    boxShadow: "shadow-menu",
    padding: "p-2",
    width: width
  }, children)));
});

export default MenuList;
//# sourceMappingURL=index.esm.js.map
